import { css } from '@emotion/core'
import { mq } from './Layout.styles'

export const styledOtherProductsBps = css(
  mq({
    marginTop: [49.5, 50, 47, 47]
  })
)

export const styledOtherProducts = css`
  ${styledOtherProductsBps};
  h5 {
    color: rgba(0, 0, 0, 0.87);
    text-align: center;
    margin-bottom: 16px;
  }
`

export const H4HeaderBps = css(
  mq({
    maxWidth: [283, 422, 680, 680],
    marginLeft: [0, 0, 200, 302],
    marginRight: [0, 0, 200, 302],
    letterSpacing: [0.25],
    textAlign: ['left', 'left', 'center', 'center'],
    marginBottom: [16]
  })
)

export const PHeaderBps = css(
  mq({
    maxWidth: [328, '100%', 680, 680],
    marginLeft: [0, 0, 200, 302],
    marginRight: [0, 0, 200, 302],
    textAlign: ['left', 'left', 'center', 'center']
  })
)

export const H4ContentBps = css(
  mq({
    fontSize: [33.6, 33.6, 33.6, 47.9],
    fontWeight: [600, 600, 600, 500]
  })
)

export const PContentBps = css(
  mq({
    maxWidth: [328, 422, 680, 680],
    marginLeft: [0, 89, 200, 302],
    marginRight: [0, 89, 200, 302],
    textAlign: ['center']
  })
)

export const spanBps = css(
  mq({
    textAlign: ['left', 'left', 'center', 'center']
  })
)

export const header = css`
  display: flex;
  text-align: center;
  span {
    ${spanBps};
    text-transform: uppercase;
    font-size: 11.8px;
    font-weight: 600;
    line-height: 1.36;
    letter-spacing: 2px;
    color: rgba(0, 0, 0, 0.6);
  }
  h4 {
    ${H4HeaderBps};
    color: rgba(0, 0, 0, 0.87);
  }
  p {
    ${PHeaderBps};
  }
  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }
`

export const faqSolutions = css`
  background-color: #f3f5f5;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const contentFaq = css`
  h4 {
    ${H4ContentBps};
    color: rgba(0, 0, 0, 0.87);
    text-align: center !important;
    margin-bottom: 16px;
  }
  p {
    ${PContentBps};
  }
`